export const LOAD_OAUTH2_AUTHORIZE_IFTTT_REQUEST = 'LOAD_OAUTH2_AUTHORIZE_IFTTT_REQUEST';
export const LOAD_OAUTH2_AUTHORIZE_IFTTT_SUCCESS = 'LOAD_OAUTH2_AUTHORIZE_IFTTT_SUCCESS';
export const LOAD_OAUTH2_AUTHORIZE_IFTTT_FAILURE = 'LOAD_OAUTH2_AUTHORIZE_IFTTT_FAILURE';
